var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-failed"},[(_vm.paymentInfo)?_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$t("receipt.payment-failed")))]),_c('TransactionDetails',{attrs:{"payment-info":_vm.transactionInfo.payment}}),_c('router-link',{attrs:{"to":{
        name: 'Pay',
        params: {
          qrCode: _vm.transactionInfo.payment.qrCode,
          currency: _vm.transactionInfo.payment.currency,
        },
      },"custom":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var navigate = ref.navigate;
return [_c('el-button',{staticClass:"primary-button",style:({ background: _vm.primaryColor }),attrs:{"type":"primary"},on:{"click":navigate}},[_vm._v(" "+_vm._s(_vm.$t("receipt.retry"))+" ")])]}}],null,false,3790322646)})],1):_c('div',[_vm._v(" "+_vm._s(_vm.$t("receipt.transaction-not-found"))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }